import { Box, Container, Grid, Space, Stack } from '@mantine/core';

import Skeleton from '@/components/Skeleton';
import { useDiscoveryContentDetailModalStyle } from '@/features/Discovery/discovery.style';

const LoadingSkeleton = () => {
  const { classes } = useDiscoveryContentDetailModalStyle();

  return (
    <div className={classes.modalContainer}>
      <Grid columns={12} gutter={12} className={classes.modalBody}>
        <Grid.Col md={8}>
          <Skeleton lines={1} height={80} contentH={35} />
          <Skeleton lines={4} height={200} contentH={25} />
          <Container p={0} w={480} maw={'90%'}>
            <Skeleton isImage height={240} />
          </Container>
          <Container p={0} my={48} maw={'90%'} w={480}>
            <Skeleton isImage height={50} />
          </Container>
        </Grid.Col>
        <Grid.Col md={4}>
          <Stack
            spacing={12}
            w={'100%'}
            h={'100%'}
            className={classes.sideContainer}
          >
            <Box w={300} maw={'60%'}>
              <Skeleton isImage height={36} />
            </Box>
            <Skeleton isImage height={36} />
            <Space my={10} />
            <Skeleton isImage height={52} />
            <Skeleton isImage height={52} />
            <Skeleton isImage height={52} />
          </Stack>
        </Grid.Col>
      </Grid>
    </div>
  );
};

export default LoadingSkeleton;
